export enum Action {
  COLLECTION = 'COLLECTION',
  CARRIER_TO_CARRIER = 'CARRIER_TO_CARRIER',
  LEAVE_AT_INTERMEDIATE = 'LEAVE_AT_INTERMEDIATE',
  PICKUP_FROM_INTERMEDIATE = 'PICKUP_FROM_INTERMEDIATE',
  DELIVERY = 'DELIVERY',
}
